export const authConstants = {
	clientId: import.meta.env.VITE_CLIENT_ID,
}
